import React from "react";
import moment from "moment";

const DueDate = props => {
  let tooltipText = moment(props.duedate).isAfter() ? "On Time" : "Past Due";
  return (
    <i
      className={`fa fa-check-square ${moment(props.duedate).isAfter() ? "text-success" : "text-muted"}`}
      aria-hidden="true"
      title={tooltipText}
    />
  );
};

export default DueDate;
